<style scoped>
    @import url("../../../styles/smartControl/alertConfig.scss");
</style>

<template>
    <div class="box_alertConfig">

        <!-- LOADING após search btn -->
        <div v-if="flagLoading" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <!-- DIALOG (confirmação de atualização) -->
        <v-dialog v-model="flagDialog" max-width="250px">
            <div class="">
                <DialogEditAlertConfirm :liAlert="liAlert" @fromDialogAlert="fromDialog($event)" 
                @reloadPagefromDialogAlert="handleEndUpdate($event)"
                />
            </div>
        </v-dialog>

        <!-- PAINEL MAIN -->
        <!-- alertas EXISTENTES (liAlert.length > 0 && )? -->
        <div v-if="!flagLoading && !flagEdit" class="painelLi">

            <v-btn 
            @click="novoAlerta()"
            class="el_btn mr-1 mb-1"
            height="160px"
            width="200px"
            style="color: green;"
            density="comfortable"
            @mouseover="corBtn='#F39C12'"
            @mouseleave="corBtn=''"
            :style="{'background':corBtn}"
            >
                <v-icon class="mr-1" size="16">mdi-plus</v-icon>
                <span>Novo Alerta</span>
            </v-btn>

            <div v-for="(el,i) in liAlert" :key="i" 
            class="elLi mr-1 mb-1"
            @mouseover="el.cor='#F39C12'"
            @mouseleave="el.cor='#C4CDD5'"
            :style="{'background':el.cor}"
            >

                <div class="t_elLi">{{ el.t }}</div>

                <v-chip @click="openAlertEdit(i)">
                    <span>Editar</span>
                    <v-icon class="ml-1" size="24">mdi-pencil-outline</v-icon>
                </v-chip>

            </div>
        </div>

        <!-- Alerta em edição -->
        <div class="painelEdit" v-if="!flagLoading && flagEdit && !flagAddGatilho">

            <div class="btnBackLine" @click="back2main()"
            @mouseover="hoverBack1 = '#f39c12'"
            @mouseleave="hoverBack1 = 'rgb(31,122,177)'"
            >
                <v-icon large class="mr-2" :style="{'color':hoverBack1}">mdi-arrow-left-thick</v-icon>
                <span>Voltar</span>
            </div>

            <v-btn 
            @click="rmvAlerta()"
            class="mt-1 mb-1 mr-2"
            height="25px"
            width="25px"
            density="comfortable"
            icon
            color="red"
            :style="{'align-self':'flex-end'}"
            >
                <v-icon size="24">mdi-close-octagon</v-icon>
            </v-btn>

            <div v-if="elEdit.t != ''" class="tit_a">{{ elEdit.t }}</div>

            <div v-if="elEdit.t == ''" class="tit_a">Novo Alerta</div>
            <v-text-field v-if="elEdit.t == ''"
            color="orange"
            v-model="elEdit.t_prev"
            :rules="limiarRules"
            label="Título do alerta"
            required
            :style="{'align-self':'center','width':'220px'}"
            ></v-text-field>

            <v-text-field
            color="orange"
            v-model="elEdit.freq_hrs"
            @input="updateLiFreqHrs(elEdit.freq_hrs)"
            :rules="limiarRules"
            label="Frequência do alerta [horas]"
            required
            :style="{'width':'220px','align-self':'center'}"
            ></v-text-field>

            <v-radio-group :style="{'align-self':'center','height':'40px'}"
            inline 
            v-model="elEdit.status"
            @update:modelValue="onBtnStatusChange"
            >
                <v-radio label="ON" value="on"></v-radio>
                <v-radio v-if="elEdit.t != ''" label="OFF" value="off"></v-radio>
            </v-radio-group>

            <!-- Selecionar se será utilizado sensor ou índice calculado para o disparo limiar -->
             <!-- Seleção de gatilho só é exibida se nenhum gatilho tiver sido atibuído ainda -->
            <div class="elSelect" v-if="elEdit.t == ''">
                <v-autocomplete
                v-model="gatilhoSelecionado"
                :items="liGatilhos"
                color="rgb(247,215,46)"
                class="w-100"
                variant="plain"
                bg-color="transparent"
                @update:modelValue="trocarGatilho"
                :style="{'padding':'4px'}"
                ></v-autocomplete>
            </div>

            <!-- ALERTA ASSOCIADO A INDICES desde a sua criação -->
            <span class="tit_box_s" v-if="flagAlertaIndice && gatilhoSelecionado != null">Índices associados</span>

            <!-- ALERTA ASSOCIADO A SENSORES desde a sua criação -->
            <span class="tit_box_s" v-if="flagAlertaSensor && gatilhoSelecionado != null">Sensores associados</span>

            <div class="box_liS" v-if="gatilhoSelecionado != null">

                <v-btn 
                @click="novoGatilho()"
                class="el_btn mr-1 mb-1"
                height="250px"
                width="200px"
                density="comfortable"
                @mouseover="corBtn='#F39C12'"
                @mouseleave="corBtn=''"
                :style="{'background':corBtn,'color':'green','white-space':'normal !important'}"
                >
                    <v-icon class="mr-1" size="16">mdi-plus</v-icon>

                    <span v-if="flagAlertaIndice">
                        Associar <br>
                        novo índice
                    </span>

                    <span v-if="flagAlertaSensor">
                        Associar <br>
                        novo sensor
                    </span>
                </v-btn>

                <!-- lista de indices/sensores já associados, se houverem -->
                <div v-for="(s,j) in elEdit.li" :key="j" class="liS mr-1 mb-1">

                    <v-btn 
                    @click="rmvAss(j)"
                    class="liSBtnRmv mb-1"
                    height="25px"
                    width="25px"
                    density="comfortable"
                    icon
                    color="red"
                    >
                        <v-icon size="24">mdi-close-octagon</v-icon>
                    </v-btn>

                    <div class="tit_s mb-6">{{ s.tit }}</div>
                    <!--<div class="tit_s mb-6">{{ s.tit_gatilho }}</div>-->

                    <v-text-field
                    color="orange"
                    v-model="s.limiar"
                    :rules="limiarRules"
                    label="Valor do limiar"
                    required
                    style="width: 200px;"
                    ></v-text-field>
                    <!-- @keyup.enter.prevent="chamada()" -->

                    <div class="tit_l">Tipo do limiar</div>

                    <v-radio-group :style="{'align-self':'center','height':'40px'}"
                    inline 
                    v-model="s.tipo_limiar"
                    @update:modelValue="onBtnStatusChange"
                    >
                        <v-radio label="Superior" value="superior"></v-radio>
                        <v-radio label="Inferior" value="inferior"></v-radio>
                    </v-radio-group>
                </div>
            </div>

            <!-- utilizando tanto em sensor quanto em indice -->
            <span v-if="flagMsg"
            :style="{'font-size':'0.8rem','color':'red','align-self':'center'}"
            >Preencha todos os campos.</span>

            <!-- BTN GERAL (habilitado somente quando edit de um alerta já existente) -->
            <v-btn v-if="indexElEdit != liAlert.length"
            @click="upAlertas()"
            class="mb-1"
            density="comfortable"
            block
            color="success"
            >
                <span>Atualizar alertas</span>
            </v-btn>
        </div>

        <!-- ASSOCIANDO UM SENSOR AO ALERTA já em edição -->
        <div class="liS_b" v-if="!flagLoading && flagAddGatilho">

            <div class="btnBackLine mb-2" @click="back2main()"
            @mouseover="hoverBack1 = '#f39c12'"
            @mouseleave="hoverBack1 = 'rgb(31,122,177)'"
            >
                <v-icon large class="mr-2" :style="{'color':hoverBack1}">mdi-arrow-left-thick</v-icon>
                <span>Voltar</span>
            </div>

            <v-chip class="mb-2">{{ elEdit.t }}</v-chip>

            <v-chip class="mb-2">{{ elEdit.freq_hrs + ' horas' }}</v-chip>

            <v-autocomplete v-if="flagAlertaIndice"
            v-model="elAss.tit"
            :items="liIndices"
            color="rgb(247,215,46)"
            class="w-100"
            @update:modelValue="trocarTit" 
            ></v-autocomplete>

            <v-autocomplete v-if="flagAlertaSensor"
            v-model="elAss.tit"
            :items="liSensores"
            color="rgb(247,215,46)"
            class="w-100"
            @update:modelValue="trocarTit" 
            ></v-autocomplete>

            <v-text-field
            color="orange"
            v-model="elAss.limiar"
            :rules="limiarRules"
            label="Valor do limiar"
            required
            style="width: 200px;"
            ></v-text-field>

            <div class="tit_l_b">Tipo do limiar</div>

            <v-radio-group :style="{'align-self':'center','height':'40px'}"
            inline 
            v-model="elAss.tipo_limiar"
            @update:modelValue="onBtnStatusChange"
            >
                <v-radio label="Superior" value="superior"></v-radio>
                <v-radio label="Inferior" value="inferior"></v-radio>
            </v-radio-group>

            <span v-if="flagMsg"
            :style="{'font-size':'0.8rem','color':'red','align-self':'center'}"
            >Preencha todos os campos.</span>

            <v-btn
            @click="assGatilho()"
            class="mb-1"
            density="comfortable"
            block
            color="success"
            >
                <span v-if="flagAlertaSensor">Associar sensor</span>
                <span v-if="flagAlertaIndice">Associar índice</span>
            </v-btn>
        </div>

    </div>
</template>

<script>
import axios from 'axios'
import DialogEditAlertConfirm from './DialogEditAlertConfirm'

export default {

    //props:['execSys', 'emailCliente'],

    components:{DialogEditAlertConfirm},

    data() {
        return {
            flagLoading:false,
            flagDialog:false,
            hoverBack1:'rgb(31,122,177)', // cor dinamica do btn voltar

            liAlert:[
                {
                    't':'Alerta A',
                    'status':'on',
                    'li_sensores':[
                        {
                            'tit_sensor':'Temperatura ar (em300th)',
                            'tipo_limiar':'superior', // ou 'inferior' (radios)
                            'limiar':90,
                        }
                    ],
                    'cor':'#C4CDD5' // <-- add ao carregar via req https
                },
                {
                    't':'Alerta B',
                    'status':'off',
                    'li_sensores':[
                        {
                            'tit_sensor':'Temperatura ar (em300th)',
                            'tipo_limiar':'inferior',
                            'limiar':12,
                        },
                        {
                            'tit_sensor':'Umidade ar (em300th)',
                            'tipo_limiar':'superior',
                            'limiar':90,
                        }
                    ],
                    'cor':'#C4CDD5'
                }
            ],
            flagEdit:false, // inicia desabilitado
            flagAddGatilho:false, // qnd able abre card de input novo associação de sensor ao alerta
            liGatilhos:['Sensor','Índice calculado'],
            gatilhoSelecionado:null,

            corBtn:'', // cor do botao (novo alerta)

            elEdit:{},
            indexElEdit:null,
            elAss:{},
            indexSensorAss:null,
            indexIndiceAss:null,
            flagMsg:false,

            //liSensores:['Temperatura ar (em300th)','Umidade ar (em300th)','Condutividade Elétrica'],
            liSensores:[],
            liObjSensores:[],
            flagAlertaSensor:false, // inidica que o alerta é associado a sensores

            liIndices:[],
            liObjIndices:[],
            flagAlertaIndice:false, // inidica que o alerta é associado a índices calculados

            limiarRules: [
                v => !!v || 'Preenchimento obrigatório',
            ],
        }
    },

    methods:{

        onBtnStatusChange(statusAlerta) { 
            //this.rBtn = statusAlerta
            //console.log('statusAlerta: ',statusAlerta)
            //console.log('liAlert: ',this.liAlert)
            //console.log('elEdit: ',this.elEdit)

            if (statusAlerta == 'superior' || statusAlerta == 'inferior') { 
                console.log('status-limiar') 
                //console.log('elAss: ',this.elAss)
            }
            else {
                // -- ON / OFF
                this.liAlert[this.indexElEdit]['status'] = statusAlerta
            }
        },

        trocarGatilho(gatilhoSelecionado) { 
            if (gatilhoSelecionado  == 'Índice calculado') {
                this.flagAlertaIndice = true
                this.flagAlertaSensor = false
            }
            else {
                this.flagAlertaIndice = false
                this.flagAlertaSensor = true
            }
            this.gatilhoSelecionado = gatilhoSelecionado 
        },

        trocarTit(valor) {
            if (this.flagAlertaSensor) {
                const idx = this.liSensores.findIndex(v => v === valor)
                this.indexSensorAss = idx // <-- id usado no associação do sensor, para obter device e key.
            }
            else {
                const idx = this.liIndices.findIndex(v => v === valor)
                this.indexIndiceAss = idx // <-- id usado no associação do sensor, para obter device e key.
            }
            //this.elAss.tit_gatilho = valor // atribuindo título ao gatilho from select
            this.elAss.tit = valor // atribuindo título ao gatilho from select
            //console.log('Índice:', idx)
            //console.log('el: ',this.liObjSensores[idx])
        },

        openAlertEdit(index2Edit) { 
            //console.log('abrir edição alerta (i): ',index2Edit); 
            // (!) -> para novo alerta, index2Edit pode quebrar a lista pois o index ainda nao existe!
            // condicionar if index == this.liAlert.length fazer push() na lista e não editar pelo index
            // index é passado por padrão

            if (index2Edit < this.liAlert.length) { 
                
                // -- bifurcar para ou é apenas um alerta de índices ou de sensores. (nunca combinados) => back separado.
                if (this.liAlert[index2Edit]['categoria'] == 's') {
                    this.flagAlertaSensor = true
                    this.flagAlertaIndice = false
                    this.gatilhoSelecionado = 'Sensor'
                }
                else {
                    this.flagAlertaSensor = false
                    this.flagAlertaIndice = true
                    this.gatilhoSelecionado = 'Índice calculado'
                }

                this.elEdit = {
                    't':this.liAlert[index2Edit]['t'],
                    'freq_hrs':this.liAlert[index2Edit]['freq_hrs'],
                    'status':this.liAlert[index2Edit]['status'],
                    'li':this.liAlert[index2Edit]['li'],
                    'utc_last_romp':this.liAlert[index2Edit]['utc_last_romp']
                }
            } 
            else { 
                const categ = this.flagAlertaSensor ? 's' : 'i'
                this.elEdit = {'t':'','freq_hrs':12,'status':'on','li':[],'t_prev':'','categoria':categ, 'utc_last_romp': ''} 
            } // NOVO ALERTA
            // t_prev apenas local

            this.indexElEdit = index2Edit // usado na operação de (rmv) e (statusChange)

            this.flagEdit = true 
        },

        novoAlerta() { 
            this.elEdit.t = '' // reset (usado para condicionar edit)
            this.elEdit.freq_hrs = 12 // init com 12h (tempo de efeito do alerta)
            this.gatilhoSelecionado = null // RESET gatilho
            //console.log('novo alerta / abrir edição ( index len(li) )') 
            this.openAlertEdit(this.liAlert.length)
        },

        novoGatilho() {
            // -- preenchimento correto/completo?
            if ( this.elEdit.t_prev == '' ) {this.flagMsg = true; return;} else {this.flagMsg = false}

            // -- se for um novo alerta senda criado, então ainda não existe título alerta
            if (this.elEdit.t == '') { this.elEdit.t = this.elEdit.t_prev }

            this.elAss = {
                'tit':'',
                'tipo_limiar':'inferior',
                'limiar':0,
                'flag_romp':false,
                'utc_romp': ''
            }
            this.flagAddGatilho = true
        },

        back2main() { 
            this.flagMsg = false // reset
            this.flagAddGatilho = false // reset (desabilitar card de associação de sensor)
            this.flagEdit = false // voltar ao menu inicial (geral alertas)
        },

        rmvAlerta() {
            //console.log('[][rmvAlerta] this.liAlert: ',this.liAlert)
            this.liAlert.splice(this.indexElEdit, 1)
            //console.log('[][rmvAlerta] this.liAlert: ',this.liAlert)
            this.back2main()
            this.flagDialog = true // abrir opção de update (pois se for rmv [0] entao nao haveria outra forma de update)
            //console.log('remover alerta (index): ',j)
            //console.log('[][rmvAlerta] end')
        },

        rmvAss(j) {
            this.liAlert[this.indexElEdit]['li'].splice(j, 1)
            //console.log('remover li ass do alerta (index li ass): ',j)
            const tam = this.liAlert[this.indexElEdit]['li'].length
            //console.log('tam: ',tam)
            // -- SE lista ass zerou, remover alerta!
            if (tam == 0) { this.rmvAlerta() }
        },

        updateLiFreqHrs(freq_hrs) {
            // -- não atualiza lista se ainda não estiver na lista, pois só é adicionado ao entrar em ass.
            // -- porém, deve aceitar edição quando estiver editando elemento já existente.
            if(this.indexElEdit != this.liAlert.length) { 
                this.liAlert[this.indexElEdit].freq_hrs = freq_hrs 
                //console.log('EDIT OK')
            }
        },

        assGatilho() {
            // -- condicionar preenchimento correto? -> sim. Precisa escolher o sensor pelo select!
            //console.log('elAss.tit_sensor: ',this.elAss.tit_sensor)
            if (this.elAss.tit == '') {this.flagMsg = true; return;} else {this.flagMsg = false}

            // -- se for um alerta novo, ele precisa existir para o push() de um sensor associado.
            if (this.indexElEdit == this.liAlert.length) {
                
                delete this.elEdit.t_prev // remover key de edição inicial da criação do novo alerta.
                this.elEdit.categoria = this.flagAlertaSensor ? 's' : 'i' // criar key de bifurcação ao atualizar com novo alerta na lista.
                this.liAlert.push(this.elEdit) // criar existência para o input pelo indice abaixo.
            }

            // --> this.indexSensorAss selecionado na func trocarTit(valor), do select do titulo do sensor em associação.
            //console.log('[assSensor]  this.liObjSensores[this.indexSensorAss]: ', this.liObjSensores[this.indexSensorAss])
            if (this.flagAlertaSensor) {
                this.elAss['device_id'] = this.liObjSensores[this.indexSensorAss]['device_id'] // sinc
                this.elAss['target_key'] = this.liObjSensores[this.indexSensorAss]['target_key'] // sinc
            }
            else {
                this.elAss['device_id'] = this.liObjIndices[this.indexIndiceAss]['device_id'] // sinc
                this.elAss['target_key'] = this.liObjIndices[this.indexIndiceAss]['target_key'] // sinc
            }

            this.liAlert[this.indexElEdit]['li'].push(this.elAss)
            console.log('[assSensor]  this.liAlert: ', this.liAlert)
            this.flagAddGatilho = false // retornar ao box do alerta em edição
        },

        fromDialog(e) { this.flagDialog = e }, // bool

        upAlertas() {
            console.log('update alertas | this.liAlert: ',this.liAlert) 

            this.flagDialog = true // abrir dialog de confirmação de update
        },

        // -- se confirmado update, os alertas devem ser atualizados também no front.
        handleEndUpdate(e) { /* BOOL from child */ if (e) { this.callInit() } },

        callInit() {
            //console.log('alert config start | buscar sensores associados a este sistema')

            this.flagLoading = true

            let emailCliente = this.$store.state.emailCliente // -- atualizado em SmartControl.vue (pai de todos) | 13/08/2025
            let sistema = this.sistema = this.$store.state.sistemaSC

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let self = this

            let params = { 
                'cliente': emailCliente,
                'sistema': sistema
            }

            let url = self.$store.state.pathAxiosBASE + '/getalertconfig' // concat

            axios.post(url, params, {headers}).then(function (res) {

                //console.log(res.data.result)
                let elMain = res.data.result
                let liI = elMain['li_indices_sistema']
                let liS = elMain['li_sensores_sistema'] // lista de obj -> tit, device_id e target_key
                let li = elMain['li_alertas_config']

                self.liIndices = []
                self.liSensores = []
                self.liAlert = [] // limpar

                // -- montar lista de titulos dos sensores disponíveis. O mesmo índice (index) contém o device_id e target_key.
                let i=0
                while (i < liS.length) {
                    self.liSensores.push(liS[i]['tit'])
                    i++
                }
                self.liObjSensores = liS

                let k=0
                while (k < liI.length) {
                    self.liIndices.push(liI[k]['tit'])
                    k++
                }
                self.liObjIndices = liI

                // MONTAR INDICES EXIBIÇÃO E EDIÇÃO.
                let statusLocal = null // aux
                let liAss = [] // aux
                let j = 0 // aux
                let el = {} // elem alerta local
                let elAss = {} // local el ass
                let liAssLocal = []
                let c = 0
                while (c < li.length) {
                    
                    liAssLocal = [] // reset local
                    //liAss = li[c]['li_indices_ass'] // rcv via req
                    liAss = li[c]?.li_indices_ass || [];
                    /*if (li_indices_ass.length == 0) {
                        // alocar lista mesmo se vazia (habilitada para edição) 31/08/2026
                    } else {*/
                    j=0
                    while (j < liAss.length) {

                        elAss = {} // reset
                        
                        if (liAss[j]['limiar_sup'] != '') { 

                            elAss['tipo_limiar'] = 'superior'
                            elAss['limiar'] = liAss[j]['limiar_sup'] // float
                        }
                        else { 

                            elAss['tipo_limiar'] = 'inferior'
                            elAss['limiar'] = liAss[j]['limiar_inf'] // float
                        }

                        elAss['tit'] = liAss[j]['tit']
                        elAss['target_key'] = liAss[j]['target_key']
                        elAss['device_id'] = liAss[j]['device_id']

                        elAss['flag_romp'] = liAss[j]['flag_romp']
                        elAss['utc_romp'] = liAss[j]['utc_romp']
                        
                        liAssLocal.push(elAss)
                        j++
                    }

                    // PERMITIR LISTA VAZIA (PARA EDITAR)? não, liAlert é formada por ou i ou s, nunca os 2 na mesma edição
                    if (liAss.length > 0) {
                        if (li[c]['flag_active'] == true) { statusLocal = 'on' }
                        else { statusLocal = 'off' }

                        el = {
                            't':li[c]['tit'],
                            'freq_hrs':li[c]['freq_hrs'],
                            'status':statusLocal,
                            'li':liAssLocal,
                            'cor':'#C4CDD5', // apenas local
                            'categoria':'i', // apenas local
                            'utc_last_romp':li[c]['utc_last_romp'],
                        }

                        self.liAlert.push(el)
                    }

                    c++
                }

                // MONTAR SENSORES EXIB E EDIÇÃO
                // -- formatação inicial para obter as keys indispensáveis ao atualizar.
                statusLocal = null // aux
                liAss = [] // aux
                j = 0 // aux
                el = {} // elem alerta local
                elAss = {} // local el ass
                liAssLocal = []
                c = 0
                while (c < li.length) {
                    
                    liAssLocal = [] // reset local
                    //liAss = li[c]['li_sensores_ass'] // rcv via req
                    liAss = li[c]?.li_sensores_ass || [];
                    j=0
                    while (j < liAss.length) {

                        elAss = {} // reset
                        
                        if (liAss[j]['limiar_sup'] != '') { 

                            elAss['tipo_limiar'] = 'superior'
                            elAss['limiar'] = liAss[j]['limiar_sup'] // float
                        }
                        else { 

                            elAss['tipo_limiar'] = 'inferior'
                            elAss['limiar'] = liAss[j]['limiar_inf'] // float
                        }

                        elAss['tit'] = liAss[j]['tit']
                        elAss['target_key'] = liAss[j]['target_key']
                        elAss['device_id'] = liAss[j]['device_id']

                        elAss['flag_romp'] = liAss[j]['flag_romp']
                        elAss['utc_romp'] = liAss[j]['utc_romp']
                        
                        liAssLocal.push(elAss)
                        j++
                    }

                    // PERMITIR LISTA VAZIA (PARA EDITAR)? não, liAlert é formada por ou i ou s, nunca os 2 na mesma edição
                    if (liAss.length > 0) {
                        if (li[c]['flag_active'] == true) { statusLocal = 'on' }
                        else { statusLocal = 'off' }

                        el = {
                            't':li[c]['tit'],
                            'freq_hrs':li[c]['freq_hrs'],
                            'status':statusLocal,
                            'li':liAssLocal,
                            'cor':'#C4CDD5', // apenas local
                            'categoria':'s', // apenas local
                            'utc_last_romp':li[c]['utc_last_romp'],
                        }

                        self.liAlert.push(el)
                    }

                    c++
                }

                //console.log('self.liAlert: ',self.liAlert)
                self.flagLoading = false // -- encerrar loading
            })
        },
    },

    created() {
        this.callInit()
    }
}
</script>